var __create = Object.create;
var __defProp = Object.defineProperty;
var __getProtoOf = Object.getPrototypeOf;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __toESM = (mod, isNodeMode, target) => {
  target = mod != null ? __create(__getProtoOf(mod)) : {};
  const to = isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target;
  for (let key of __getOwnPropNames(mod))
    if (!__hasOwnProp.call(to, key))
      __defProp(to, key, {
        get: () => mod[key],
        enumerable: true
      });
  return to;
};
var __commonJS = (cb, mod) => () => (mod || cb((mod = { exports: {} }).exports, mod), mod.exports);

// node_modules/loglevel/lib/loglevel.js
var require_loglevel = __commonJS((exports, module) => {
  (function(root, definition) {
    if (typeof define === "function" && define.amd) {
      define(definition);
    } else if (typeof module === "object" && exports) {
      module.exports = definition();
    } else {
      root.log = definition();
    }
  })(exports, function() {
    var noop = function() {
    };
    var undefinedType = "undefined";
    var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ];
    function bindMethod(obj, methodName) {
      var method = obj[methodName];
      if (typeof method.bind === "function") {
        return method.bind(obj);
      } else {
        try {
          return Function.prototype.bind.call(method, obj);
        } catch (e) {
          return function() {
            return Function.prototype.apply.apply(method, [obj, arguments]);
          };
        }
      }
    }
    function traceForIE() {
      if (console.log) {
        if (console.log.apply) {
          console.log.apply(console, arguments);
        } else {
          Function.prototype.apply.apply(console.log, [console, arguments]);
        }
      }
      if (console.trace)
        console.trace();
    }
    function realMethod(methodName) {
      if (methodName === "debug") {
        methodName = "log";
      }
      if (typeof console === undefinedType) {
        return false;
      } else if (methodName === "trace" && isIE) {
        return traceForIE;
      } else if (console[methodName] !== undefined) {
        return bindMethod(console, methodName);
      } else if (console.log !== undefined) {
        return bindMethod(console, "log");
      } else {
        return noop;
      }
    }
    function replaceLoggingMethods(level, loggerName) {
      for (var i = 0;i < logMethods.length; i++) {
        var methodName = logMethods[i];
        this[methodName] = i < level ? noop : this.methodFactory(methodName, level, loggerName);
      }
      this.log = this.debug;
    }
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
      return function() {
        if (typeof console !== undefinedType) {
          replaceLoggingMethods.call(this, level, loggerName);
          this[methodName].apply(this, arguments);
        }
      };
    }
    function defaultMethodFactory(methodName, level, loggerName) {
      return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }
    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;
      defaultLevel = defaultLevel == null ? "WARN" : defaultLevel;
      var storageKey = "loglevel";
      if (typeof name === "string") {
        storageKey += ":" + name;
      } else if (typeof name === "symbol") {
        storageKey = undefined;
      }
      function persistLevelIfPossible(levelNum) {
        var levelName = (logMethods[levelNum] || "silent").toUpperCase();
        if (typeof window === undefinedType || !storageKey)
          return;
        try {
          window.localStorage[storageKey] = levelName;
          return;
        } catch (ignore) {
        }
        try {
          window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
        } catch (ignore) {
        }
      }
      function getPersistedLevel() {
        var storedLevel;
        if (typeof window === undefinedType || !storageKey)
          return;
        try {
          storedLevel = window.localStorage[storageKey];
        } catch (ignore) {
        }
        if (typeof storedLevel === undefinedType) {
          try {
            var cookie = window.document.cookie;
            var location = cookie.indexOf(encodeURIComponent(storageKey) + "=");
            if (location !== -1) {
              storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
            }
          } catch (ignore) {
          }
        }
        if (self.levels[storedLevel] === undefined) {
          storedLevel = undefined;
        }
        return storedLevel;
      }
      function clearPersistedLevel() {
        if (typeof window === undefinedType || !storageKey)
          return;
        try {
          window.localStorage.removeItem(storageKey);
          return;
        } catch (ignore) {
        }
        try {
          window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
        } catch (ignore) {
        }
      }
      self.name = name;
      self.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      };
      self.methodFactory = factory || defaultMethodFactory;
      self.getLevel = function() {
        return currentLevel;
      };
      self.setLevel = function(level, persist) {
        if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
          level = self.levels[level.toUpperCase()];
        }
        if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
          currentLevel = level;
          if (persist !== false) {
            persistLevelIfPossible(level);
          }
          replaceLoggingMethods.call(self, level, name);
          if (typeof console === undefinedType && level < self.levels.SILENT) {
            return "No console available for logging";
          }
        } else {
          throw "log.setLevel() called with invalid level: " + level;
        }
      };
      self.setDefaultLevel = function(level) {
        defaultLevel = level;
        if (!getPersistedLevel()) {
          self.setLevel(level, false);
        }
      };
      self.resetLevel = function() {
        self.setLevel(defaultLevel, false);
        clearPersistedLevel();
      };
      self.enableAll = function(persist) {
        self.setLevel(self.levels.TRACE, persist);
      };
      self.disableAll = function(persist) {
        self.setLevel(self.levels.SILENT, persist);
      };
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
        initialLevel = defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }
    var defaultLogger = new Logger;
    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
      if (typeof name !== "symbol" && typeof name !== "string" || name === "") {
        throw new TypeError("You must supply a name when creating a logger.");
      }
      var logger = _loggersByName[name];
      if (!logger) {
        logger = _loggersByName[name] = new Logger(name, defaultLogger.getLevel(), defaultLogger.methodFactory);
      }
      return logger;
    };
    var _log = typeof window !== undefinedType ? window.log : undefined;
    defaultLogger.noConflict = function() {
      if (typeof window !== undefinedType && window.log === defaultLogger) {
        window.log = _log;
      }
      return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
      return _loggersByName;
    };
    defaultLogger["default"] = defaultLogger;
    return defaultLogger;
  });
});

// src/Components/Attempts.js
function Attempts(props) {
  const { currentAttempts } = props;
  return `
    <div class="text-gray-400 text-right text-base font-light pt-2 pr-8">
      ${currentAttempts}/10 Attempts Remaining Today
    </div>
  `;
}

// src/Components/FormSelect.js
function FormSelect(props) {
  const { className, name, id, options, required } = props;
  return `
  <div>
    <div class="text-black text-base font-light mt-6 ${className}">${name}</div>
    <div class="border-[color:var(--Light-Purple,#AC8EC2)] flex items-stretch justify-between gap-5 mt-2 px-5 py-4 rounded-[100px] border-[1.5px] border-solid max-md:px-5">
      <label for="proportion" class="text-gray-400 text-base font-light grow shrink basis-auto relative">
        <select id="${id}" name="${id}" required=${required} class="w-full hide-select-arrow border-none h-auto min-h-auto p-0 m-0 bg-white">
          ${options.map((option) => {
    let selected = false;
    if ("selected" in option)
      selected = option.selected;
    return `<option ${selected ? "selected" : ""} value="${option.value}">${option.name}</option>`;
  }).join("")}
        </select>
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/d23f001e394b32f409eb6313ba84ce358179d92a45c00476af59c17be98f5e38?apiKey=d7b03ef3e1b041b686cffd40f6d0657b&"
          class="aspect-[1.82] object-contain object-center w-5 stroke-[2px] stroke-violet-900 overflow-hidden shrink-0 max-w-full z-10 right-0 top-1/3 -translate-x-1/2 absolute"
        />
      </label>
    </div>
  </div>
  `;
}

// src/Components/FormInput.js
function FormInput(props) {
  const { className, name, id, placeholder, required, inputType } = props;
  let inputEl = `<input id="${id}" name="${id}" type="text" required=${required} placeholder="${placeholder}" class="w-full h-auto min-h-auto p-0 m-0 border-none bg-white">`;
  if (inputType === "textarea") {
    inputEl = `<textarea id="${id}" name="${id}" required=${required} placeholder="${placeholder}" class="w-full h-auto min-h-[40px] p-0 m-0 border-none bg-white resize-none overflow-hidden" oninput="this.style.height = 'auto'; this.style.height = this.scrollHeight + 'px';"></textarea>`;
  }
  return `
  <div>
    <div class="text-black text-base font-light mt-6 ${className}">${name}</div>
    <div class="border-[color:var(--Light-Purple,#AC8EC2)] flex items-stretch justify-between gap-5 mt-2 px-5 py-4 rounded-[100px] border-[1.5px] border-solid max-md:px-5">
      <label for="proportion" class="text-gray-400 text-base font-light grow shrink basis-auto relative">
        ${inputEl}
      </label>
    </div>
  </div>
  `;
}

// src/Components/StartOverBtn.js
function StartOverBtn(props) {
  const { currentAttempts } = props;
  if (currentAttempts <= 0) {
    return "";
  }
  return `
    <button type="button" class="aicook-reset startOver bg-[#F6F6F6] self-stretch flex w-full flex-col justify-center items-center mt-6 px-12 py-5 rounded-[50px] max-md:mt-4 max-md:px-5">
      <div class="flex items-stretch gap-2.5">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/4b2b84e7af6cf1df9822221be413d0c97b84103add18b76897dcae8439ab2a59?"
          class="aspect-square object-contain object-center w-5 stroke-[1.5px] stroke-white overflow-hidden shrink-0 max-w-full"
        />
        <div class="text-black text-lg md:text-xl font-semibold grow leading-5 text-left">
          I don't love it. Let's start again
        </div>
      </div>
    </button>
  `;
}

// src/Components/Generating.js
var import_loglevel = __toESM(require_loglevel(), 1);
function Generating(props) {
  import_loglevel.default.info("Generating()", props);
  const { desktopOnly, mobileOnly } = props;
  return `
    <div class="aicook-generating absolute top-0 left-full h-full w-full bg-[#A53C89] flex opacity-0 transition ease-in-out justify-center items-center flex-col ${desktopOnly ? "hidden md:flex" : ""} ${mobileOnly ? "md:hidden" : ""}">
      <div class="fontQuicksand text-white font-semibold pb-10 text-xl md:text-3xl">
        Creating Image Now\u2026 
      </div>
      <div class="z-10 relative">
        <svg class="w-32 aick-spinner" width="116" height="110" viewBox="0 0 116 110" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M101.055 30C92.3981 15.055 76.2174 5 57.6849 5C36.6725 5 18.6833 17.9261 11.2558 36.25M85.8485 36.25H110.883V11.25M14.828 80C23.4851 94.945 39.6659 105 58.1983 105C79.2107 105 97.1999 92.0739 104.627 73.75M30.0347 73.75H5.00045V98.75" stroke="white" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20">
          <svg class="w-11" width="49" height="46" viewBox="0 0 49 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M39.4175 25.2949C39.4523 26.6087 38.9571 27.9336 37.9318 28.9363L24.8005 41.7791C22.8173 43.7187 19.6019 43.7187 17.6187 41.7791L4.4874 28.9363C3.46215 27.9336 2.96692 26.6087 3.00171 25.2949M39.4175 25.2949C39.3879 24.1774 38.9749 23.0679 38.1786 22.1712C38.0866 21.9733 37.9575 21.788 37.7911 21.6252L21.4406 5.634M39.4175 25.2949H3.00171M3.00171 25.2949C3.03422 24.0673 3.52945 22.8492 4.4874 21.9123C4.82501 21.5821 21.4406 5.634 21.4406 5.634M21.4406 5.634L18.7475 3M43.5808 34.8361C43.421 34.5893 43.1471 34.4324 42.8504 34.4324C42.5537 34.4324 42.2798 34.5895 42.12 34.8361C41.5494 35.756 39.7008 38.8967 39.7008 40.2652C39.7008 41.9701 41.1158 43.3611 42.8504 43.3611C44.5849 43.3611 46 41.9702 46 40.2652C46 38.8743 44.1514 35.7559 43.5808 34.8361Z" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>      
        </div>
      </div>
    </div>
  `;
}

// src/Components/GenerateForm.js
var inputPrompt = {
  className: "",
  name: "What do you want an image of?",
  id: "prompt",
  placeholder: "An astronaut riding a rainbow unicorn\u2026",
  required: true,
  inputType: "textarea"
};
var selectProportion = {
  className: "",
  name: "Proportion",
  id: "proportion",
  options: [
    {
      name: "Square (1x1)",
      value: "square"
    },
    {
      name: "Portrait (3x4)",
      value: "portrait"
    },
    {
      name: "Landscape (4x3)",
      value: "landscape"
    }
  ],
  required: true
};
var selectStyle = {
  className: "",
  name: "Style",
  id: "style",
  options: [
    {
      name: "Cozy Dream",
      value: "cozy"
    },
    {
      name: "Bright Fantasy",
      value: "fantasy"
    },
    {
      name: "Impressionist Painting",
      value: "impressionist"
    },
    {
      name: "Contemporary Animation",
      value: "contemporary"
    },
    {
      name: "Dark Fantasy Cover",
      value: "dark_fantasy"
    },
    {
      name: "Child-Like Wonder",
      value: "childlike"
    },
    {
      name: "Spooky",
      value: "spooky"
    },
    {
      name: "Hyperrealistic",
      value: "hyperrealistic"
    },
    {
      name: "Illustrated Poster",
      value: "poster"
    },
    {
      name: "Retrowave",
      value: "retrowave"
    },
    {
      name: "Psychodelic",
      value: "psychodelic"
    },
    {
      name: "Cinematic",
      value: "cinematic"
    },
    {
      name: "Cosmic",
      value: "cosmic"
    },
    {
      name: "Baroque Romantic",
      value: "baroque"
    },
    {
      name: "Americana Deco",
      value: "americana"
    },
    {
      name: "Cyberpunk",
      value: "cyberpunk"
    },
    {
      name: "Unstyled",
      value: "no_assistance"
    }
  ],
  required: true
};
selectStyle.options.sort((a, b) => {
  if (a.name < b.name) {
    return -1;
  }
  return 1;
});
function GenerateForm(props) {
  const { currentGenerated, isIteration: isIteration2, currentAttempts } = props;
  if (isIteration2) {
    inputPrompt.name = "What would you like to adjust?";
  }
  selectProportion.options.forEach((option) => {
    if (option.value === currentGenerated.proportion) {
      option.selected = true;
    }
  });
  selectStyle.options.forEach((option) => {
    if (option.value === currentGenerated.style) {
      option.selected = true;
    } else {
      delete option.selected;
    }
  });
  inputPrompt.placeholder = currentGenerated.prompt;
  let submitBtn = "";
  if (currentAttempts <= 10 && currentAttempts > 0) {
    submitBtn = `
    <button type="submit" class="bg-fuchsia-800 flex w-full flex-col justify-center items-center mt-8 px-16 py-5 rounded-[50px] max-md:mt-10 max-md:px-5 disabled:opacity-40 disabled:cursor-not-allowed">
        <div class="flex items-stretch gap-2.5">
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/f43383f2677ea7d24dbdeac9d4f720b4994003a239303da9fe5da10ff5bdfc47?apiKey=d7b03ef3e1b041b686cffd40f6d0657b&"
            class="aspect-[0.9] object-contain object-center w-[18px] overflow-hidden shrink-0 max-w-full"
          />
          <div class="fontQuicksand text-white text-xl font-semibold self-center grow whitespace-nowrap my-auto">
            Generate
          </div>
        </div>
      </button>
    `;
  } else {
    submitBtn = `
    <button type="button" disabled class="bg-fuchsia-800 flex w-full flex-col justify-center items-center mt-8 px-16 py-5 rounded-[50px] max-md:mt-10 max-md:px-5 disabled:opacity-40 disabled:cursor-not-allowed">
      <div class="flex items-stretch gap-2.5">
        <div class="fontQuicksand text-white text-xl font-semibold self-center grow whitespace-nowrap my-auto">
          10 Credits Used
        </div>
      </div>
    </button>
  `;
  }
  let proportionEl = FormSelect(selectProportion);
  if (isIteration2) {
    proportionEl = `<input type="hidden" name="proportion" value="${currentGenerated.proportion}"/>`;
  }
  let lastImage = "";
  let acceptCurrent = "";
  if (isIteration2) {
    lastImage = `
    <input type="hidden" name="lastImage" value="${currentGenerated.url}"/>
    `;
    acceptCurrent = `
      <button type="button" class="aicook-trigger-current-complete bg-[#F6F6F6] self-stretch flex w-full flex-col justify-center items-center mt-6 px-16 py-5 rounded-[50px] max-md:mt-10 max-md:px-5">
        <div class="flex items-stretch gap-2.5">
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/4b2b84e7af6cf1df9822221be413d0c97b84103add18b76897dcae8439ab2a59?"
            class="aspect-square object-contain object-center w-5 stroke-[1.5px] stroke-white overflow-hidden shrink-0 max-w-full"
          />
          <div class="text-black text-xl font-semibold grow leading-5 text-left">
            Actually, I just want to use this one!
          </div>
        </div>
      </button>
    `;
  }
  return `
    <form class="aicook-generate-form flex grow flex-col items-stretch mt-11 px-5 md:pl-10 max-md:mt-10 bg-white">
      ${lastImage}
      <div class="fontQuicksand text-black text-3xl font-semibold">
        Generate Your Image With AI!
      </div>
      <div class="text-gray-500 text-base font-light mt-4">
      Unleash your imagination
      </div>
      <div class="bg-neutral-100 self-stretch flex flex-col justify-center items-center mt-6 w-full py-0 md:hidden relative">
        ${Generating({ desktopOnly: false, mobileOnly: true })}
        <img
          loading="lazy"
          src="${currentGenerated.url}"
          class="w-full max-md:h-2/3 object-contain object-center stroke-[4px] stroke-gray-400 overflow-hidden max-w-full p-4"
        />
      </div>
      <div class="fontQuicksand text-black text-3xl font-semibold whitespace-nowrap mt-6 max-md:mt-10">
        ${isIteration2 ? "Let\u2019s Adjust." : "Let\u2019s Get Started."}
      </div>
      <div class="text-gray-500 text-base font-light mt-3">
        Now you have the power to create your own custom diamond paintings 
        from scratch! Use our new AI-powered platform and simply begin 
        describing your dream image below.
        <span class="text-xs font-light block pt-2 text-gray-400">
        Please note that you can make up to 10 designs per day.
        </span>
      </div>
      ${FormInput(inputPrompt)}
      ${FormSelect(selectStyle)}
      ${proportionEl}
      ${submitBtn}
      ${acceptCurrent}
      ${isIteration2 ? StartOverBtn({ currentAttempts: 0 }) : ""}
    </form>`;
}

// src/Components/UserMetDailyQuota.js
function UserMetDailyQuota(props) {
  const { currentAttempts } = props;
  if (currentAttempts > 0) {
    return "";
  }
  return `
    <div class="aicook-met-daily-quota shadow-xl bg-purple-100 flex flex-col px-7 pt-7 pb-12 rounded-3xl max-w-[440px] w-4/5 md:w-1/2 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
      <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/46ab7395895fb58de1b84b3c48d6fbb1a7ebc85544efd7ceecf833f669c09694?"
        class="closeDailyQuota aspect-square object-contain object-center w-3.5 stroke-[2px] stroke-black overflow-hidden max-w-full self-end hover:cursor-pointer"
      />
      <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/d57fa320e270b38b376fd3cd2ef2621dd5c1e46229a825cad91f478e2e825aa8?"
        class="aspect-[0.69] object-contain object-center w-[33px] stroke-[3px] stroke-black overflow-hidden self-center max-w-full mt-6"
      />
      <div class="text-black text-center text-3xl font-semibold max-w-[297px] self-center mt-6">
        You\u2019ve Used Your <br />
        10 Credits For Today.
      </div>
      <div class="text-black text-center text-base font-light self-stretch mt-6 mb-5">
        Please select an image or return again
        <br />
        tomorrow if you\u2019re interested in trying again!
      </div>
    </div>
  `;
}

// src/Components/Initial.js
var import_loglevel2 = __toESM(require_loglevel(), 1);
function Initial(props) {
  const { currentAttempts, currentGenerated, isIteration: isIteration2 } = props;
  import_loglevel2.default.info("Initial()", props);
  return `
    <div class="relative w-full pb-12 overflow-hidden">
      ${UserMetDailyQuota({ currentAttempts })}
      <div class="gap-5 flex max-md:flex-col max-md:items-stretch max-md:gap-0 pt-8 max-h-full">
        <div class="flex flex-col items-stretch md:w-[45%] lg:w-[32%] max-md:w-full max-md:ml-0">
          ${GenerateForm({ currentGenerated, isIteration: isIteration2, currentAttempts })}
        </div>
        <div class="flex flex-col items-stretch md:w-[55%] lg:w-[68%] ml-5 max-md:w-full max-md:ml-0 max-h-full overflow-hidden relative">
          <div class="flex grow flex-col items-end mr-8">
            ${Attempts({ currentAttempts })}
            <div class=" self-stretch flex-col justify-center items-center max-md:max-w-full hidden md:flex min-h-full max-h-full overflow-hidden relative">
              <div class="absolute h-[82%] top-[4%] w-auto stroke-[4px] stroke-gray-400 flex items-center justify-center p-8 ">
                <img
                  loading="lazy"
                  src="${currentGenerated.url}"
                  class="w-auto max-h-full block"
                />
              </div>
            </div>
          </div>
          ${Generating({ desktopOnly: true, mobileOnly: false })}
        </div>
      </div>
    </div>`;
}

// node_modules/js-cookie/dist/js.cookie.mjs
var assign = function(target) {
  for (var i = 1;i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
};
var init = function(converter, defaultAttributes) {
  function set(name, value, attributes) {
    if (typeof document === "undefined") {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === "number") {
      attributes.expires = new Date(Date.now() + attributes.expires * 86400000);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = "";
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += "; " + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }
      stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
    }
    return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
  }
  function get(name) {
    if (typeof document === "undefined" || arguments.length && !name) {
      return;
    }
    var cookies = document.cookie ? document.cookie.split("; ") : [];
    var jar = {};
    for (var i = 0;i < cookies.length; i++) {
      var parts = cookies[i].split("=");
      var value = parts.slice(1).join("=");
      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);
        if (name === found) {
          break;
        }
      } catch (e) {
      }
    }
    return name ? jar[name] : jar;
  }
  return Object.create({
    set,
    get,
    remove: function(name, attributes) {
      set(name, "", assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function(attributes) {
      return init(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function(converter2) {
      return init(assign({}, this.converter, converter2), this.attributes);
    }
  }, {
    attributes: { value: Object.freeze(defaultAttributes) },
    converter: { value: Object.freeze(converter) }
  });
};
/*! js-cookie v3.0.5 | MIT */
var defaultConverter = {
  read: function(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
var api = init(defaultConverter, { path: "/" });

// src/index.js
var import_loglevel5 = __toESM(require_loglevel(), 1);

// src/Components/CompleteBtn.js
function CompleteBtn(props) {
  const { isLast } = props;
  return `
    <button type="button" class="bg-[#A53C89] self-stretch flex w-full flex-col justify-center items-center mt-14 px-16 py-5 rounded-[50px] max-md:mt-10 max-md:px-5">
      <div class="flex items-stretch gap-2.5">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/ed6679a75bbce10767269fe5cf21dbb4e2d428b3e18487d60cbde6e325489329?"
          class="aspect-square object-contain object-center w-5 stroke-[1.5px] stroke-white overflow-hidden shrink-0 max-w-full"
        />
        <div class="${isLast ? "aicook-trigger-last-complete" : "aicook-trigger-current-complete"} text-white text-xl font-semibold grow whitespace-nowrap text-left">
          This looks great
          <span class="text-xs font-light block">Proceed to Choose Your Size</span>
        </div>
      </div>
    </button>
  `;
}

// src/Components/AdjustBtn.js
function AdjustBtn(props) {
  const { currentAttempts, isLast } = props;
  if (currentAttempts <= 0) {
    return "";
  }
  return `
    <button type="button" class="${isLast ? "aicook-adjust-last-view" : "aicook-adjust-current-view"} bg-[#F6F6F6] self-stretch flex w-full flex-col justify-center items-center mt-6 px-16 py-5 rounded-[50px] max-md:mt-10 max-md:px-5">
      <div class="flex items-stretch gap-2.5">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/4b2b84e7af6cf1df9822221be413d0c97b84103add18b76897dcae8439ab2a59?"
          class="aspect-square object-contain object-center w-5 stroke-[1.5px] stroke-white overflow-hidden shrink-0 max-w-full"
        />
        <div class="text-black text-xl font-semibold grow leading-5 text-left">
        We are close! I just want to adjust this.
        </div>
      </div>
    </button>
  `;
}

// src/Components/SuccessForm.js
function SuccessForm(props) {
  const { currentGenerated, currentAttempts } = props;
  return `
    <form class="aicook-generate-form flex grow flex-col items-stretch mt-11 px-5 md:pl-10 max-md:mt-10">
      <div class="fontQuicksand text-black text-3xl font-semibold">
        Success!
      </div>
      <div class="text-gray-500 text-base font-light mt-3">
        This is a bit of text that explains how cool it was that they just used 
        AI to generate an image for them, and that now they have to choose how 
        they want to proceed.
      </div>

      <div class="bg-neutral-100 self-stretch flex flex-col justify-center items-center mt-6 w-full py-0 md:hidden">
        <img
          loading="lazy"
          src="${currentGenerated.url}"
          class="w-full max-md:h-2/3 object-contain object-center stroke-[4px] stroke-gray-400 overflow-hidden max-w-full p-4"
        />
      </div>

      <div>
        ${CompleteBtn({ isLast: false })}
        ${StartOverBtn({ currentAttempts })}
      </div>
    </form>`;
}

// src/Components/Success.js
var import_loglevel3 = __toESM(require_loglevel(), 1);
function Success(props) {
  const { currentAttempts, currentGenerated } = props;
  import_loglevel3.default.info("Success()", props);
  return `
    <div class="relative w-full pb-12 overflow-hidden">
      ${UserMetDailyQuota({ currentAttempts })}
      <div class="gap-5 flex max-md:flex-col max-md:items-stretch max-md:gap-0 pt-8 max-h-full lg:min-h-[50vw]">
        <div class="flex flex-col items-stretch md:w-[45%] lg:w-[32%] max-md:w-full max-md:ml-0">
          ${SuccessForm({ currentGenerated, currentAttempts })}
        </div>
        <div class="flex flex-col items-stretch md:w-[55%] lg:w-[68%] ml-5 max-md:w-full max-md:ml-0 max-h-full relative">
          <div class="flex grow flex-col items-end mr-8">
            ${Attempts({ currentAttempts })}
            <div class="bg-neutral-100 self-stretch flex-col justify-center items-center max-md:max-w-full hidden md:flex min-h-full max-h-full overflow-hidden relative">
              <div class="absolute h-[82%] top-[4%] w-auto stroke-[4px] stroke-gray-400 flex items-center justify-center p-8 ">
                <img
                  loading="lazy"
                  src="${currentGenerated.url}"
                  class="w-auto max-h-full block"
                />
              </div>
            </div>
          </div>
          ${Generating({ desktopOnly: true, mobileOnly: false })}
        </div>
      </div>
    </div>`;
}

// src/Components/Compare.js
var import_loglevel4 = __toESM(require_loglevel(), 1);
function Compare(props) {
  const { currentAttempts, lastGenerated, currentGenerated } = props;
  import_loglevel4.default.info("Compare()", props);
  const lastStyleName = selectStyle.options.find((option) => option.value === lastGenerated.style).name;
  const currentStyleName = selectStyle.options.find((option) => option.value === currentGenerated.style).name;
  const lastProportionName = selectProportion.options.find((option) => option.value === lastGenerated.proportion).name;
  const currentProportionName = selectProportion.options.find((option) => option.value === currentGenerated.proportion).name;
  return `
    <div class="relative w-full pb-12 overflow-hidden">
      ${UserMetDailyQuota({ currentAttempts })}
      ${Attempts({ currentAttempts })}
      <div class="fontQuicksand text-black text-3xl font-semibold">
        Generate Your Image With AI!
      </div>
      <div class="text-gray-500 text-base font-light mt-4">
      Unleash your imagination
      </div>
      <div class="gap-5 flex max-md:flex-col max-md:items-stretch max-md:gap-0 pt-8 max-h-full">
        <div class="flex flex-col items-stretch md:w-[50%] max-md:w-full max-md:ml-0">
          <div class="flex grow flex-col items-end mr-8">
            <div class="bg-neutral-100 self-stretch flex-col justify-center items-center max-md:max-w-full flex min-h-[50vw] max-h-[50vw] overflow-hidden relative">
              <div class="absolute h-[90%] top-[4%] w-auto stroke-[4px] stroke-gray-400 flex items-center justify-center p-8 ">
                <img
                  loading="lazy"
                  src="${lastGenerated.url}"
                  class="w-auto max-h-full block"
                />
              </div>
            </div>
          </div>
          <div class="p-8 max-w-md">
            <div class="text-black text-base font-light mt-1"><strong class="mr-1">Prompt:</strong>${lastGenerated.prompt}</div>
            <div class="text-black text-base font-light mt-1"><strong class="mr-1">Style:</strong>${lastStyleName}</div>
            <div class="text-black text-base font-light mt-1"><strong class="mr-1">Proportion:</strong>${lastProportionName}</div>
            ${CompleteBtn({ isLast: true })}
            ${AdjustBtn({ currentAttempts, isLast: true })}
            ${StartOverBtn({ currentAttempts })}
          </div>
        </div>
        <div class="flex flex-col items-stretch justify-start md:w-[50%] ml-5 max-md:w-full max-md:ml-0 max-h-full">
          <div class="flex grow flex-col items-end mr-8">
            <div class="bg-neutral-100 self-stretch flex-col justify-center items-center max-md:max-w-full flex min-h-[50vw] max-h-[50vw] max-h-full overflow-hidden relative">
              <div class="absolute h-[90%] top-[4%] w-auto stroke-[4px] stroke-gray-400 flex items-center justify-center p-8 ">
                <img
                  loading="lazy"
                  src="${currentGenerated.url}"
                  class="w-auto max-h-full block"
                />
              </div>
            </div>
          </div>
          <div class="p-8 max-w-md">
            <div class="text-black text-base font-light mt-1"><strong class="mr-1">Prompt:</strong>${currentGenerated.prompt}</div>
            <div class="text-black text-base font-light mt-1"><strong class="mr-1">Style:</strong>${currentStyleName}</div>
            <div class="text-black text-base font-light mt-1"><strong class="mr-1">Proportion:</strong>${currentProportionName}</div>
            ${CompleteBtn({ isLast: false })}
            ${AdjustBtn({ currentAttempts, isLast: false })}
            <button class="aicook-reset startOver text-[#B9BBBF] text-sm underline mt-2 p-4 bg-white opacity-0">
              Let\u2019s Start Over
            </button>
          </div>
        </div>
      </div>
    </div>`;
}

// src/Components/ErrorView.js
function ErrorView(props) {
  const { message } = props;
  return `
    <div class="relative w-full pb-12 overflow-hidden md:min-h-[50vw] min-h-full">
      ${Generating({ desktopOnly: false, mobileOnly: false })}
      <div class="aicook-met-daily-quota shadow-xl bg-purple-100 flex flex-col px-7 pt-7 pb-12 rounded-3xl max-w-[440px] w-4/5 md:w-1/2 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/46ab7395895fb58de1b84b3c48d6fbb1a7ebc85544efd7ceecf833f669c09694?"
          class="closeDailyQuota aspect-square object-contain object-center w-3.5 stroke-[2px] stroke-black overflow-hidden max-w-full self-end hover:cursor-pointer"
        />
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/d57fa320e270b38b376fd3cd2ef2621dd5c1e46229a825cad91f478e2e825aa8?"
          class="aspect-[0.69] object-contain object-center w-[33px] stroke-[3px] stroke-black overflow-hidden self-center max-w-full mt-6"
        />
        <div class="text-black text-center text-3xl font-semibold max-w-[297px] self-center mt-6">
          ${message}
        </div>
        <div class="text-black text-center text-base font-light self-stretch mt-6 mb-5">
          Please return again
          <br />
          later if you\u2019re interested in trying again!
        </div>
      </div>
    </div>
    
  `;
}

// src/index.js
var getCustomerID = function() {
  try {
    let curr = window.ShopifyAnalytics.meta.page.customerId;
    if (curr !== undefined && curr !== null && curr !== "") {
      return curr;
    }
  } catch (e) {
  }
  try {
    let curr = window.meta.page.customerId;
    if (curr !== undefined && curr !== null && curr !== "") {
      return curr;
    }
  } catch (e) {
  }
  try {
    let curr = _st.cid;
    if (curr !== undefined && curr !== null && curr !== "") {
      return curr;
    }
  } catch (e) {
  }
  try {
    let curr = ShopifyAnalytics.lib.user().traits().uniqToken;
    if (curr !== undefined && curr !== null && curr !== "") {
      return curr;
    }
  } catch (e) {
  }
  return `anon-${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}`;
};
var getMidnightPST = function() {
  const tmrwUtc = new Date;
  tmrwUtc.setDate(tmrwUtc.getDate() + 1);
  tmrwUtc.setUTCHours(0, 0, 0, 0);
  const pstDateTime = new Date(tmrwUtc);
  const offset = -8 * 60;
  pstDateTime.setMinutes(pstDateTime.getMinutes() + offset);
  const now = new Date;
  if (pstDateTime < now)
    pstDateTime.setDate(pstDateTime.getDate() + 1);
  return pstDateTime;
};
var setLogLevel = function(logLevel) {
  if (logLevel) {
    import_loglevel5.default.setLevel(logLevel);
    import_loglevel5.default.debug(`setLogLevel() - set to ${logLevel}`);
    return;
  }
  import_loglevel5.default.setDefaultLevel("error");
};
var defaultGenerated = {
  prompt: "An astronaut riding a rainbow unicorn",
  proportion: "square",
  style: "cinematic",
  url: "https://cdn.shopify.com/s/files/1/0061/0687/3922/files/example-rainbow-unicorn.png?v=1702012653"
};
window.ddCook = (props) => {
  console.log("CRS", "ddCook()");
  const { logLevel, wsEndpoint, apiEndpoint } = props;
  setLogLevel(logLevel);
  const rootEl = $("#dd-cook");
  const showInitialLayout = () => {
    import_loglevel5.default.debug("showInitialLayout()");
    rootEl.lastGenerated = defaultGenerated;
    rootEl.currentGenerated = defaultGenerated;
    rootEl.html(Initial({
      currentAttempts: getAttempts(),
      currentGenerated: rootEl.currentGenerated
    }));
    const generateFormEl = rootEl.find(".aicook-generate-form");
    generateFormEl.on("submit", (e) => submitGenerateForm(e, generateFormEl));
  };
  const showAdjustLayout = (isLast) => {
    import_loglevel5.default.debug("showAdjustLayout()");
    let currentGenerated = rootEl.currentGenerated;
    if (isLast)
      currentGenerated = rootEl.lastGenerated;
    rootEl.currentGenerated = currentGenerated;
    rootEl.html(Initial({
      currentAttempts: getAttempts(),
      currentGenerated,
      isIteration: true
    }));
    const generateFormEl = rootEl.find(".aicook-generate-form");
    generateFormEl.on("submit", (e) => submitGenerateForm(e, generateFormEl));
    rootEl.find(".aicook-reset").on("click", (e) => showInitialLayout());
    rootEl.find(".aicook-trigger-current-complete").on("click", (e) => passOffImage(false));
  };
  const showSuccessLayout = () => {
    import_loglevel5.default.debug("showSuccessLayout()");
    rootEl.html(Success({
      currentAttempts: getAttempts(),
      currentGenerated: rootEl.currentGenerated
    }));
    rootEl.find(".aicook-trigger-current-complete").on("click", (e) => passOffImage(false));
    rootEl.find(".aicook-adjust-current-view").on("click", (e) => showAdjustLayout());
    rootEl.find(".aicook-reset").on("click", (e) => showInitialLayout());
    rootEl.find(".closeDailyQuota").on("click", (e) => {
      $(".aicook-met-daily-quota").hide();
    });
  };
  const showErrorView = (props2) => {
    import_loglevel5.default.debug("showErrorView()");
    rootEl.html(ErrorView(props2));
    toggleGeneratingOverlay(true);
    rootEl.find(".closeDailyQuota").on("click", (e) => {
      showInitialLayout();
    });
  };
  const showCompareLayout = () => {
    import_loglevel5.default.debug("showCompareLayout()");
    rootEl.html(Compare({
      currentAttempts: getAttempts(),
      lastGenerated: rootEl.lastGenerated,
      currentGenerated: rootEl.currentGenerated
    }));
    rootEl.find(".aicook-trigger-last-complete").on("click", (e) => passOffImage(true));
    rootEl.find(".aicook-trigger-current-complete").on("click", (e) => passOffImage(false));
    rootEl.find(".aicook-adjust-last-view").on("click", (e) => showAdjustLayout(true));
    rootEl.find(".aicook-adjust-current-view").on("click", (e) => showAdjustLayout(false));
    rootEl.find(".aicook-reset").on("click", (e) => showInitialLayout());
    rootEl.find(".closeDailyQuota").on("click", (e) => {
      $(".aicook-met-daily-quota").hide();
    });
  };
  const setAttempts = async (attempts) => {
    import_loglevel5.default.debug("setAttempts()");
    const resp = await api.set("dailyAttempts", attempts, {
      expires: getMidnightPST()
    });
    import_loglevel5.default.debug("setAttempts - cookie set", resp);
    if (attempts <= 0) {
      import_loglevel5.default.debug("getAttempts - daily limit hit");
      sendAPIDailyMet();
    }
  };
  const getAttempts = () => {
    import_loglevel5.default.info("getAttempts()");
    var attempts = api.get("dailyAttempts");
    if (attempts === undefined) {
      import_loglevel5.default.debug("getAttempts - cookie undefined");
      attempts = 10;
      setAttempts(attempts);
    }
    return parseInt(attempts);
  };
  const sendAPIDailyMet = async () => {
    const customerID = getCustomerID();
    const resp = await fetch(`${apiEndpoint}/daily-met/${customerID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    import_loglevel5.default.debug("getAttempts - daily-met API called", resp);
  };
  const toggleGeneratingOverlay = (show) => {
    import_loglevel5.default.debug("toggleGeneratingOverlay()", show);
    const overlayEl = rootEl.find(".aicook-generating");
    const generateFormInputs = rootEl.find(".aicook-generate-form input, .aicook-generate-form button");
    if (show === true) {
      overlayEl.removeClass("left-full").addClass("left-0");
      overlayEl.removeClass("opacity-0").addClass("opacity-90");
      generateFormInputs.each(function() {
        this.disabled = true;
      });
      return;
    }
    overlayEl.addClass("opacity-0 hidden").removeClass("opacity-90");
    generateFormInputs.each(function() {
      this.disabled = false;
    });
  };
  const passOffImage = async (isLast) => {
    import_loglevel5.default.debug("passOffImage()");
    window.aiUrl = isLast ? rootEl.lastGenerated.url : rootEl.currentGenerated.url;
    window.shouldBypassWithAI = true;
    if (logLevel === "debug") {
      import_loglevel5.default.debug(window.aiUrl, window.shouldBypassWithAI);
      return;
    }
    $("#ck-trigger-upload").trigger("click");
  };
  const updateAndShowGeneratedImage = async (formData, output, isIteration2) => {
    import_loglevel5.default.debug("updateGeneratedImage()", formData, output, isIteration2);
    rootEl.lastGenerated = rootEl.currentGenerated;
    rootEl.currentGenerated = {
      ...formData,
      url: output
    };
    await setAttempts(getAttempts() - 1);
    toggleGeneratingOverlay(false);
    if (isIteration2) {
      showCompareLayout();
      return;
    }
    showSuccessLayout();
  };
  const submitGenerateForm = async (e, formEl) => {
    import_loglevel5.default.debug("submitGenerateForm()", e, formEl);
    e.preventDefault();
    if (getAttempts() < 0) {
      showErrorView({ message: "You have used all of your credits." });
      return;
    }
    const formData = Object.fromEntries(new FormData(formEl[0]).entries());
    isIteration = ("lastImage" in formData);
    if (isIteration) {
      formData.source_prompt = rootEl.currentGenerated.prompt;
    }
    const jsonFormData = JSON.stringify(formData);
    console.log("formData", formData);
    toggleGeneratingOverlay(true);
    $([document.documentElement, document.body]).animate({
      scrollTop: $("#dd-cook").offset().top
    }, 600);
    const ws = new WebSocket(wsEndpoint);
    ws.onopen = async () => {
      import_loglevel5.default.info("ws - open");
      import_loglevel5.default.info("ws - sending msg", jsonFormData);
      ws.send(jsonFormData);
      ws.onmessage = async (event) => {
        import_loglevel5.default.info("ws - received msg", event.data);
        await ws.close();
        import_loglevel5.default.info("ws - closed");
        let eventData;
        try {
          eventData = JSON.parse(event.data);
        } catch (e2) {
          import_loglevel5.default.error("ws - error parsing msg to json", e2);
          return;
        }
        if (!("output" in eventData)) {
          if (eventData.status === "error" && eventData.message === "API limit reached") {
            showErrorView({
              message: "This service has reached its daily quota."
            });
            return;
          }
          import_loglevel5.default.error("ws - error", event.data);
          showErrorView({ message: "Something went wrong." });
          return;
        }
        if (logLevel === "debug") {
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
        await updateAndShowGeneratedImage(formData, eventData.output, isIteration);
      };
    };
  };
  import_loglevel5.default.debug("ddCook init", props);
  showInitialLayout();
  return null;
};
